/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c3d9d0a0 (Wed Sep 23 18:58:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface ProgramDirectoryReportRow
 */
export interface ProgramDirectoryReportRow {
  /**
   * The parent's first name.
   * @type string
   * @memberof ProgramDirectoryReportRow
   */
  parentFirstName: string
  /**
   * The parent's last name.
   * @type string
   * @memberof ProgramDirectoryReportRow
   */
  parentLastName: string
  /**
   * The parent's login email (username).
   * @type string
   * @memberof ProgramDirectoryReportRow
   */
  parentEmail: string
  /**
   * The parent's phone number.
   * @type string
   * @memberof ProgramDirectoryReportRow
   */
  parentPhone?: string
  /**
   * The student's first name.
   * @type string
   * @memberof ProgramDirectoryReportRow
   */
  studentFirstName: string
  /**
   * The student's birth month (1-12).
   * @type number
   * @memberof ProgramDirectoryReportRow
   */
  studentBirthMonth?: number
  /**
   * The student's birth year.
   * @type number
   * @memberof ProgramDirectoryReportRow
   */
  studentBirthYear?: number
  /**
   * The enrollment status key (enrollment.enrollmentStatusKey). Only ENROLLED and COMPLETE enrollments are included in this report.
   * @type string
   * @memberof ProgramDirectoryReportRow
   */
  enrollmentStatus: string
  /**
   * The date the current enrollment status took effect (enrollment.enrollmentStatusValidFrom), in date format: `yyyy-MM-dd`.
   * @type Date
   * @memberof ProgramDirectoryReportRow
   */
  enrollmentStatusDate?: Date
  /**
   * The date the student was enrolled (enrollment.enrolledDate), in date format: `yyyy-MM-dd`.
   * @type Date
   * @memberof ProgramDirectoryReportRow
   */
  enrolledDate?: Date
}

export function ProgramDirectoryReportRowFromJSON(
  json: any
): ProgramDirectoryReportRow {
  return ProgramDirectoryReportRowFromJSONTyped(json, false)
}

export function ProgramDirectoryReportRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProgramDirectoryReportRow {
  if (json === undefined || json === null) {
    return json
  }
  return {
    parentFirstName: json['parentFirstName'],
    parentLastName: json['parentLastName'],
    parentEmail: json['parentEmail'],
    parentPhone: !exists(json, 'parentPhone') ? undefined : json['parentPhone'],
    studentFirstName: json['studentFirstName'],
    studentBirthMonth: !exists(json, 'studentBirthMonth')
      ? undefined
      : json['studentBirthMonth'],
    studentBirthYear: !exists(json, 'studentBirthYear')
      ? undefined
      : json['studentBirthYear'],
    enrollmentStatus: json['enrollmentStatus'],
    enrollmentStatusDate: !exists(json, 'enrollmentStatusDate')
      ? undefined
      : new Date(json['enrollmentStatusDate']),
    enrolledDate: !exists(json, 'enrolledDate')
      ? undefined
      : new Date(json['enrolledDate']),
  }
}

export function ProgramDirectoryReportRowToJSON(
  value?: ProgramDirectoryReportRow | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    parentFirstName: value.parentFirstName,
    parentLastName: value.parentLastName,
    parentEmail: value.parentEmail,
    parentPhone: value.parentPhone,
    studentFirstName: value.studentFirstName,
    studentBirthMonth: value.studentBirthMonth,
    studentBirthYear: value.studentBirthYear,
    enrollmentStatus: value.enrollmentStatus,
    enrollmentStatusDate:
      value.enrollmentStatusDate === undefined
        ? undefined
        : value.enrollmentStatusDate.toISOString().substr(0, 10),
    enrolledDate:
      value.enrolledDate === undefined
        ? undefined
        : value.enrolledDate.toISOString().substr(0, 10),
  }
}
